export interface ProjectData {
  id: number;
  title: string;
  description: string;
  image_url: string;
  project_url: string;
  color_accent: string;
  category: string;
  featured: boolean;
  created_at: string;
}

export const projects: ProjectData[] = [
  {
    "id": 5,
    "title": "YouTool.io",
    "description": "A powerful suite of analytics and growth tools built specifically for YouTube creators. Turn data into actionable insights that help you understand what your audience truly wants.",
    "image_url": "https://64.media.tumblr.com/377e88f933f314338ba9608900174dc9/7c0180d0d1212074-5a/s1280x1920/a048ccb1bec91251584811a90d7551c9f7b4ceb7.pnj",
    "project_url": "https://www.youtool.io",
    "color_accent": "#bf2c1f",
    "category": "Analytics",
    "featured": true,
    "created_at": "2025-05-20T05:48:02.924591+00:00"
  },
  {
    "id": 4,
    "title": "Smooth It",
    "description": "Smooth It creates and applies custom easing curves to keyframed properties.",
    "image_url": "https://64.media.tumblr.com/ac6b24eb89f0c1a5968cdeff134b1d87/de37173ea8e82b4a-76/s1280x1920/be943a97ff80dbace88c7692a05f7f3747901641.pnj",
    "project_url": "https://exchange.adobe.com/apps/cc/fc1418c4/smooth-it",
    "color_accent": "#4287f5",
    "category": "Editing Tools",
    "featured": false,
    "created_at": "2022-05-20T13:58:11+00:00"
  },
  {
    "id": 3,
    "title": "Clipboard It",
    "description": "Reimagining how editors share and reuse elements between projects. Designed for professionals who need to move fast without sacrificing quality or creative flow.",
    "image_url": "https://imgproxy.fourthwall.com/NSD2usD9hYTysLDRn1nsl2le1Wj4LLGV3f-bqk1H1X0/w:720/sm:1/enc/OTk0NmI0NjQ1Yzli/YTczNN7v8sTooFr_/69APhnk512swjQmE/LU9wZ_gIvt3bh8II/9lan9TDd1fgslTKJ/_rVZKHQCjnTmPrYM/UTZavpQa9yN10avg/fBm3bDJjQOw1jAVI/S4jsp4uU7ius6dKQ/D20X9SLihVh0HP6e/8hBCkYiyyD_uUslv/E8aUFXGNSvdoX8no/KeRqwkLy-Jf2qmDF/OG5FrQ.webp",
    "project_url": "https://clipboard.it.com",
    "color_accent": "#8338EC",
    "category": "Editing Tools",
    "featured": false,
    "created_at": "2025-05-20T05:48:02.924591+00:00"
  },
  {
    "id": 2,
    "title": "Link-In-Bio Page Maker",
    "description": "Beautiful link pages that reflect your personal brand. Eliminate the middleman and take control of your audience and their journey with custom designs that captivate and convert.",
    "image_url": "https://imgproxy.fourthwall.com/-sRNLeEHYub1Mu4_xFNuPc95aDsiehM3lx357-MSABA/w:720/sm:1/enc/MzNhNjY2ZDQxNTgw/MTFjOOWDEr73rTRg/jwnx6r_nJ5Q8_Q4i/ON0Gp-3RzRCwFgkV/1sJ8rfpnzD8j-hv_/owsCCRovJvvByk81/45hia7fp97fjLYLh/OqcUnH2RioER1EPb/DqyBl2UODmnwBUiM/nXAeCzvDqreP605T/ag5EijuzGACLixFm/CnRSPj53pkbblXYN/Qrgts9LR--shPaga/z8WyYg.webp",
    "project_url": "https://www.youtool.io/tools/link-in-bio-builder",
    "color_accent": "#06D6A0",
    "category": "Creator Tools",
    "featured": false,
    "created_at": "2025-05-20T05:48:02.924591+00:00"
  },
  {
    "id": 1,
    "title": "Notion Templates",
    "description": "Planner templates for content creators. Includes the YouTube Planner and Planner+.",
    "image_url": "https://64.media.tumblr.com/c01181b742fa764eab63dd7544a073c8/9e2beede650be6dd-4e/s1280x1920/dccedfb87e52ef0ab653c694afd2dc57721d0665.pnj",
    "project_url": "https://www.notion.so/@austindavenport",
    "color_accent": "#d1d1d1",
    "category": "Productivity Tools",
    "featured": false,
    "created_at": "2023-06-20T02:37:12+00:00"
  }
];
